module.exports = __webpack_public_path__ + "static/media/dragiconvector.dbe1f5bb.png";